import { RequiredSecurities } from '../../../../../shared/constants/required-securities';
import { SecurityEntityLevel } from '../../../../../shared/constants/security-group';
import { IRequiredSecurity } from '../../../../../shared/interfaces/security.interface';

export const ORGANIZATION_ROUTE_REQUIRED_SECURITY: IRequiredSecurity[] = [
  {
    entityLevel: SecurityEntityLevel.digitalProperty,
    functionalActions: {
      ...RequiredSecurities.GR_Organization_Dashboard_Read.functionalActions,
      ...RequiredSecurities.Organization_Portfolio_Read.functionalActions,
      ...RequiredSecurities.Common_Findings_Read.functionalActions,
      ...RequiredSecurities.ReportingAgent_Read_Create_No_Entity_Level.functionalActions,
    },
  },
  RequiredSecurities.Program_Portfolio_Read,
];
